<template>
    <AppModal
        ref="modalRef"
        v-model="isVisible"
        size="xl"
        v-if="user?.id"
    >
        <template #header>
            <h3 class="modal-title">
                {{ $t("Activity Log") }}
            </h3>
        </template>

        <template #default>
            <DataTable
                :key="user.id"
                :url="`/api/support/activity-logs/user/${user.id}`"
                :columns="columns"
                :searchingEnabled="false"
                :hideTableActions="true"
                order-by="created_at"
                order-dir="desc"
            >
            </DataTable>
        </template>

        <template #footer>
            <AppButton btnClass="btn-white" @click="closeModal">
                <AppIcon :icon="faClose" />
                {{ $t("Close") }}
            </AppButton>
        </template>
    </AppModal>
</template>

<script setup lang="ts">
import { nextTick, PropType, ref } from "vue";
import AppModal from "@/vue/shared/AppModal.vue";
import AppButton from "@/vue/shared/AppButton.vue";
import AppIcon from "@/vue/shared/AppIcon.vue";
import { trans as $t } from "laravel-vue-i18n";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { type User } from "@/vue/types/user";
import DataTable from "@/vue/datatable/DataTable.vue";
import useDates from "@/libs/dates/useDates";

const isVisible = defineModel<boolean>({ default: false });
const modalRef = ref<any>(null);

const props = defineProps({
    user: {
        type: Object as PropType<User>,
        required: true
    }
});

const closeModal = () => nextTick(modalRef.value?.closeModal);
const { format } = useDates();

const columns = [
    { data: "event", title: $t("Event") },
    { data: "description", title: $t("Description") },
    {
        data: "properties",
        title: $t("Attributes"),
        render: (data: { [key: string]: string }) => JSON.stringify(data, null, 2),
        pre: true
    },
    {
        data: "created_at",
        title: $t("Created At"),
        render: (data: string) => format(data, "MM/DD/YYYY HH:mm:ss"),
        visible: true
    }
];

</script>